var map = {
	"./Fish_1.png": 2097,
	"./Fish_10.png": 852,
	"./Fish_11.png": 5070,
	"./Fish_12.png": 9928,
	"./Fish_13.png": 9552,
	"./Fish_14.png": 1400,
	"./Fish_15.png": 4002,
	"./Fish_16.png": 4945,
	"./Fish_17.png": 3499,
	"./Fish_18.png": 8909,
	"./Fish_19.png": 2374,
	"./Fish_2.png": 1555,
	"./Fish_20.png": 7186,
	"./Fish_21.png": 6744,
	"./Fish_22.png": 1862,
	"./Fish_23.png": 7366,
	"./Fish_24.png": 2311,
	"./Fish_25.png": 6970,
	"./Fish_3.png": 2596,
	"./Fish_4.png": 2639,
	"./Fish_5.png": 285,
	"./Fish_6.png": 5710,
	"./Fish_7.png": 7039,
	"./Fish_8.png": 5661,
	"./Fish_9.png": 1653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7077;